import React from 'react';
import _ from 'lodash';
// mui
import { Divider, Card } from '@mui/material';
import { makeStyles } from '@mui/styles';

// components
import { useParams } from 'react-router-dom';
import {
  getConsolidatesKeys,
  getCoverages,
} from '../../../_global/endorsements/endorsement.utils';
import { CoveragesSummary } from '../../../_global/endorsements/comparisons/CoveragesSummary';
import SubHeader from '../../../agencies/endorsement/components/SubHeader';
import EndorsementHeader from '../../../agencies/endorsement/components/EndorsementHeader';
import SummaryAdditionalInsured from './SummaryAdditionalInsured';
import SummaryPolicyDuration from './SummaryPolicyDuration';
import SummaryInsuredInformation from './SummaryInsuredInformation';
import AttestSubmit from '../../quotes/AttestSubmit';
import { ProductTypes } from '../../../../types';
import P100SummaryInsuredInformation from './P100SummaryInsuredInformation';
import { resolveP100RaterVersionFromEntity } from '../../../workflows/quotes/prime-100/utils';

export const EndorsementSummary = ({ quote, policy, onSubmit }: any) => {
  const classes = useClasses();
  // @ts-expect-error TS(2339): Property 'product' does not exist on type '{}'.
  const { product } = useParams();

  const headerData = {
    companyName: _.get(quote, 'companyName'),
    naicsCode: _.get(quote, 'firmographicData.naicsCode'),
    primaryIndustry: _.get(quote, 'firmographicData.primaryIndustry'),
  };
  const effectiveDate = _.get(quote, 'initialRequestData.effectiveDate');
  const boostRaterVersion =
    resolveP100RaterVersionFromEntity(quote) ??
    resolveP100RaterVersionFromEntity(policy);

  const policyCoverages = getCoverages(policy, product);
  const endorsementCoverages = getCoverages(
    {
      ...quote,
      ..._.get(quote, 'initialRequestData'),
    },
    product
  );

  const consolidatedKeys = getConsolidatesKeys(quote);

  return (
    <Card className={classes.card}>
      <EndorsementHeader
        data={headerData}
        readOnly={false}
        onSubmit={onSubmit}
      />

      <Divider className={classes.dividerStyle} />

      <SubHeader
        currentSelectedDate={effectiveDate}
        policyDetails={policy}
        readOnly
      />

      {product === ProductTypes.p100 && (
        <>
          <P100SummaryInsuredInformation
            show={quote?.coveragesUpated?.includes('insuredInfo')}
            insuredInformation={{
              ...quote?.initialRequestData?.address,
              companyName: quote?.initialRequestData?.companyName,
            }}
          />
          <CoveragesSummary
            previous={{
              ...policyCoverages.coverages,
              additionalInsureds: _.get(policy, 'additionalInsured', []),
            }}
            current={{
              ...endorsementCoverages.coverages,
              additionalInsureds: _.get(
                quote,
                'initialRequestData.additionalInsureds',
                []
              ),
            }}
            existingKeys={consolidatedKeys}
            boostRaterVersion={boostRaterVersion}
          />
        </>
      )}

      {product === ProductTypes.p250 && (
        <SummaryInsuredInformation insuredInformation={quote} />
      )}
      <SummaryAdditionalInsured
        AI={_.get(quote, 'initialRequestData.additionalInsureds', [])}
      />
      {/* we need to send term in the duartion (don't have the info), currently PH side is not shown on the platform so we are good till then */}
      {product === ProductTypes.p250 && (
        <SummaryPolicyDuration
          endDate={quote?.initialRequestData?.endDate}
          policyDetails={policy}
        />
      )}
      <AttestSubmit quote={quote} />
    </Card>
  );
};

const useClasses = makeStyles(() => ({
  dividerStyle: {
    margin: '1.33rem 2rem',
  },
  card: {
    padding: '2.25rem 2rem 1rem',
  },
  buttonLayout: {
    textAlign: 'center',
    padding: '0.66rem 0',
  },
}));
